import { TableV2 } from '@anytag/shared-atoms';
import { InstagramInteractionTaggedPost } from '@anytag/graphql';
import { PostDetailsType, TableData } from '@anytag/shared-types';
import { InstagramInteractionTaggedPostDetailsModal } from '@anytag/shared-molecules';
import { useAnalyticsInstagramTaggedPostsListTable } from './hooks';

export interface AnalyticsInstagramTaggedPostsListProps extends TableData<InstagramInteractionTaggedPost> {
  mainSocialAccountId: number;
}

export const AnalyticsInstagramTaggedPostsList = ({
  loading,
  data = [],
  mainSocialAccountId
}: AnalyticsInstagramTaggedPostsListProps) => {
  const { columns } = useAnalyticsInstagramTaggedPostsListTable();

  return (
    <>
      <TableV2 data={data} loading={loading} columns={columns} rowHeight="62px" noTopBorderRadius hasBorder />

      <InstagramInteractionTaggedPostDetailsModal
        posts={data.map(({ id }): PostDetailsType => ({ id, mainSocialAccountId }))}
      />
    </>
  );
};
